import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { DesignToken, ShadowToken } from "@livechat/design-system-react-components";

import { withFiltersData } from "components/filters";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Filters as FiltersList } from "components/filters/Filters";
import { Filter, IFilters } from "constants/filters";
import { ReportDistribution } from "constants/reports/distribution";
import { ReportType } from "constants/reports/report-type";
import { getFiltersByReportType } from "helpers/reports";
import { IStoreState } from "interfaces/storeState";
import { IAgent, selectAgentsAlphabetically, selectLoggedInAgent } from "store/entities/agents";
import { ITarget } from "store/entities/application-settings/interfaces";
import { selectAuditLogTargets, selectLanguageLabels } from "store/entities/application-settings/selectors";
import { ITag, selectReportsTags } from "store/entities/tags";
import { ITeam, selectTeamsPerPermission } from "store/entities/teams";
import {
  IReportsViewFilters,
  IReportsViewUpdateFilterPayload,
  ReportsViewActions,
  getCurrentView,
  getDistribution,
  getFilters,
  getFiltersOrder,
  hasReportComparisonDisabled,
} from "store/views/reports/";
import { withVar } from "themes/helpers";

import { DistributionToggler } from "./DistributionToggler";
import { buildAvailableFilters } from "./helpers";

const FiltersWithData = withFiltersData(FiltersList);

const barStyles = css`
  box-shadow: ${withVar(ShadowToken.DividerBottom)};
  padding: 15px 20px;
  display: flex;
`;

const filtersWrapperStyles = css`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;

const StyledLabel = styled.label`
  margin-right: 8px;
  font-size: 15px;
  line-height: 38px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

interface IStateProps {
  currentAgent: IAgent;
  agents: IAgent[];
  teams: ITeam[];
  tags: ITag[];
  filters: IReportsViewFilters;
  filtersOrder: Filter[];
  distribution: ReportDistribution;
  reportType: ReportType;
  disableComparison?: boolean;
  targets: Record<string, ITarget>;
  languageLabels: Record<string, string>;
}

interface IDispatchProps {
  onDistributionChange(type?: ReportDistribution): void;
  onFilterUpdate<T extends keyof IReportsViewFilters>(filter: IReportsViewUpdateFilterPayload<T>): void;
}

interface IProps extends IStateProps, IDispatchProps {
  disableDistribution?: boolean;
}

class UnconnectedFilters extends PureComponent<IProps> {
  handleDistributionChange = (): void => {
    this.props.onDistributionChange(
      this.props.distribution === ReportDistribution.Hour ? undefined : ReportDistribution.Hour
    );
  };

  render(): JSX.Element {
    const {
      agents,
      tags,
      teams,
      filters,
      filtersOrder,
      distribution,
      onFilterUpdate,
      reportType,
      disableDistribution,
      disableComparison,
      currentAgent,
      targets,
      languageLabels,
    } = this.props;

    const filtersList = getFiltersByReportType(reportType);

    const dateRangeValues = {
      ...filters[Filter.DateRange],
    };

    delete dateRangeValues.compare;

    const filtersValues: IFilters = {
      ...filters,
      // @ts-expect-error TS(2418)
      [Filter.DateRange]: dateRangeValues,
      [Filter.Group]: filters.group && filters.group.groups,
      [Filter.Agent]: filters.agent && filters.agent.agents,
    };

    const compareFilterValues: IFilters = {
      [Filter.DateRange]: filters[Filter.DateRange]?.compare,
      [Filter.Group]: filters[Filter.Group] && filters[Filter.Group].compare,
      [Filter.Agent]: filters[Filter.Agent] && filters[Filter.Agent].compare,
    };

    return (
      <div css={barStyles}>
        <div css={filtersWrapperStyles}>
          <StyledLabel>Filters:</StyledLabel>
          <div>
            <FiltersWithData
              availableFilters={buildAvailableFilters(teams, tags, filtersList, disableComparison)}
              agents={agents}
              currentAgent={currentAgent}
              groups={teams}
              tags={tags}
              filters={filtersValues}
              compareFilters={!disableComparison ? compareFilterValues : undefined}
              filtersOrder={filtersOrder}
              // @ts-expect-error TS(2322)
              onFilterUpdate={onFilterUpdate}
              isReports
              targets={targets}
              languageLabels={languageLabels}
            />
          </div>
        </div>
        <div>
          {!disableDistribution && (
            <DistributionToggler
              on={distribution === ReportDistribution.Hour}
              onClick={this.handleDistributionChange}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  agents: selectAgentsAlphabetically(state),
  currentAgent: selectLoggedInAgent(state),
  teams: selectTeamsPerPermission(state),
  tags: selectReportsTags(state),
  filters: getFilters(state),
  filtersOrder: getFiltersOrder(state),
  distribution: getDistribution(state),
  reportType: getCurrentView(state),
  disableComparison: hasReportComparisonDisabled(state),
  targets: selectAuditLogTargets(state),
  languageLabels: selectLanguageLabels(state),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  onDistributionChange: (type: ReportDistribution) => dispatch(ReportsViewActions.setReportDistribution(type)),
  onFilterUpdate: <T extends keyof IReportsViewFilters>(filter: IReportsViewUpdateFilterPayload<T>) =>
    // @ts-expect-error TS(2345)
    dispatch(ReportsViewActions.updateFilter(filter)),
});

export const Filters = connect(mapStateToProps, mapDispatchToProps)(UnconnectedFilters);
